import config from '@/config'
import i18n from '@/locale'
import { appStore } from '@/stores'
// 官网首页
const websiteHome = appStore.isCN ? config.localeLangs['zh-CN'].websiteHome : config.localeLangs['en-US'].websiteHome
const language = appStore.language
// 官网多语言首页地址
let websiteLangHome = ''
// 收银台链接
let checkoutHost = import.meta.env.VITE_CHECKOUT_URL_EN
const checkoutSign = import.meta.env.VITE_CHECKOUT_SIGN_URL_EN
if (appStore.isCN) {
  checkoutHost = import.meta.env.VITE_CHECKOUT_URL_CN
  websiteLangHome = config.localeLangs['zh-CN'].websiteHome
} else if (language === 'zh-CN') {
  // 针对某些用户使用海外用户中心的中文语言，访问官网或者收银台应该对应的还是海外环境，默认英语
  websiteLangHome = config.localeLangs['zh-HK'].websiteHome
} else {
  websiteLangHome = config.localeLangs[language].websiteHome
}

// 多语言
const { t } = i18n.global
export default {
  // 支付状态
  payStatus: {
    0: t('Unpaid'),
    1: t('Failure'),
    2: t('Paid'),
    3: t('Refunded'),
    4: t('Pending'),
  },
  // 产品id
  goodsProductId: {
    CLOUD: 25647,
    UPDF: [25643, 25644, 25645, 25646, 25647],
    AI_UNLIMITED_EN: 25652,
    AI_STANDARD_EN: 25648,
    AI_UNLIMITED_CN: 25653,
    AI_STANDARD_CN: 25651,
    SIGN_EN: 25654,
  },
  sendCaptchaType: {
    // 发送验证码类型
    login: 1,
    register: 2,
    forgetPass: 3,
    resetPass: 3,
    createCompany: 6,
  },
  userColors: [
    // 用户头像背景色
    '#67DBC0',
    '#FF8080',
    '#A661FF',
    '#55B2E7',
    '#FAD200',
  ],
  planTypeName: {
    // Plan卡片类型名称
    freeTrial: 'Free Trial',
    free: 'Free',
    freeAi: 'Free',
    freeSign: 'Free',
    annually: 'Annual',
    monthly: 'Monthly',
    quarterly: 'Quarterly',
    lifetime: 'Perpetual',
    giveaway: 'Giveaway',
    cloud: 'UCloud',
    monthlyAi: 'MonthlyAi',
  },
  websiteUrl: {
    // 官网链接
    homeLink: websiteHome, // 官网首页
    homeLangLink: websiteLangHome, // 官网多语言首页
    licenseUrl: `${websiteHome}license-agreement/`, // 许可协议
    privacyUrl: `${websiteHome}privacy-policy/`, // 隐私政策
    subscriptionUrl: `${websiteHome}software-subscription-agreement/`, // 订阅协议
    faqLink: `${websiteLangHome}updf-faqs/`, // 常见问题
    contactUsLink: `${websiteLangHome}contact-us/`, // 联系我们
    featuresLink: `${websiteLangHome}tech-spec/`, // 产品功能
    educationLink: `${websiteLangHome}education/`,
    downloadLink: `${websiteLangHome}download/`, // 下载页面
    pricingIndividuals: `${websiteLangHome}pricing-individuals/`, // 个人版收银台
    pricingEnterprises: `${websiteLangHome}pricing-enterprises/`, // 企业版收银台
    pricingEducation: `${websiteLangHome}pricing-education/`, // 教育版收银台
    pricingSign: `${checkoutSign}/pricing/individuals/`, // 数字签名收银台收银台
    // 收银台链接
    bindCardIframe: `${checkoutHost}/iframe/binding-card/`, // 绑定信用卡链接
  },
}
